import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import AFrameScene from "./components/AFrameScene";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AFrameScene />} />
      </Routes>
    </Router>
  );
}

export default App;
